import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import CopyToClipboard from 'react-copy-to-clipboard';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';


class LinkButton extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleClick = this.handleClick.bind(this);
    this.onCopy = this.onCopy.bind(this);
  }

  onCopy() {
    this.context.addNotification((
      <div>
        Direct URL to this page was copied to your clipboard!
      </div>
    ));
  }

  getURL() {
    const { params, location } = this.props;
    if (!params) {
      return null;
    }
    const { pathname, search } = location;
    const query = queryString.parse(search);
    const mergedParams = { ...query, ...params };
    const url = `${pathname}?${queryString.stringify(mergedParams)}`;
    let prefix = null;
    if (typeof window !== 'undefined' && window.location) {
      prefix = `${window.location.protocol}//${window.location.host}`;
    }
    return `${prefix}${url}`;
  }

  handleClick(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  render() {
    const url = this.getURL();
    if (!url || url.length > 2048) {
      return null;
    }
    return (
      <CopyToClipboard
        text={url}
        onCopy={this.onCopy}
      >
        <a
          href={url}
          target="_blank"
          onClick={this.handleClick}
        >
          <Fa name="share" /> Copy URL
        </a>
      </CopyToClipboard>
    );
  }
}

LinkButton.propTypes = {
  location: PropTypes.shape({}).isRequired,
  params: PropTypes.shape({}),
};
LinkButton.defaultProps = {
  params: null,
};

LinkButton.contextTypes = {
  router: PropTypes.shape({}).isRequired,
  addNotification: PropTypes.func.isRequired,
};

export default withRouter(LinkButton);
